import React from 'react';
import {PublisherSimilarBookListModel} from "../../../models/publisher/publisher-similar-book-list.model";
import {Chip, Grid} from "@material-ui/core";
import styled from "styled-components";
import {StyledSmallButton} from "../../ui-base/small-button";
import LinearProgress from "@material-ui/core/LinearProgress";
import blankProfile from "../../../img/blank-profile.png";
import {Colors} from "../../../theme/colors";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {BaseService} from "../../../services/base.service";


export const PublisherBookShort: React.FC<{manuscript: PublisherSimilarBookListModel}> = ({manuscript}) => {
    const history = useHistory();
    const { t } = useTranslation(['publisher', 'common']);

    return (
        <Grid item sm={12} style={{maxWidth: '100%'}}>
            <StyledContainer item container direction={'column'} spacing={2}>

                <Grid item container direction={"row"} justifyContent={"space-between"}>
                    <Grid item xs={12} sm container direction={"column"}>
                        {manuscript.matching &&
                            <StyledMatchingContainer item container direction={"column"} spacing={1}>
                                <Grid item container direction={"row"} justifyContent={"space-between"}>
                                    <Grid item>
                                        <p>{t('bookShort.matching')}</p>
                                    </Grid>

                                    <Grid item>
                                        <p>{Math.round(manuscript.matching * 100)}%</p>
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    <LinearProgress variant="determinate" value={manuscript.matching * 100}/>
                                </Grid>
                            </StyledMatchingContainer>
                        }

                        <Grid item container direction={"row"} spacing={1}>
                            <Grid item xs={"auto"}>
                                <StyledAuthorImage src={manuscript.author.photo?.file || blankProfile}/>
                            </Grid>
                            <Grid item container direction={"column"} xs justifyContent={"space-around"}>
                                <Grid item>
                                    <StyledH5>{manuscript.manuscript.title}</StyledH5>
                                </Grid>
                                <Grid item>
                                    <StyledH6>{manuscript?.author?.first_name + ' ' + manuscript?.author?.last_name}</StyledH6>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={"auto"}>
                        <Grid item>
                            <p><span style={{fontWeight: 'bold'}}>{t('common:status')}: </span>{t(`common:applicationStatus.status${manuscript.status}`)}</p>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item container direction={"row"} spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <StyledSpan1>{'bookShort.fragment'}:</StyledSpan1>
                        <p style={{whiteSpace: 'pre-line'}}>{BaseService.cutText(manuscript.manuscript.fragment, 500) || '-'}</p>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <StyledSpan1>{'bookShort.desc'}:</StyledSpan1>
                        <p style={{whiteSpace: 'pre-line'}}>{BaseService.cutText(manuscript.manuscript.description, 500) || '-'}</p>
                    </Grid>
                </Grid>

                <Grid item container direction={"row"} spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <StyledSpan1>{t('common:categories')}:</StyledSpan1>
                        <Grid container direction={'row'} spacing={1}>
                            {manuscript.manuscript.categories.map((category) => (
                                <Grid item key={category.id} style={{maxWidth: '100%'}}>
                                    <Chip label={category.name} style={{maxWidth: '100%'}} />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <StyledSpan1>{t('common:tags')}:</StyledSpan1>
                        <Grid container direction={'row'} spacing={1}>
                            {manuscript.manuscript.tags.filter((tag) => tag.tag_type === 'tag').map((tag) => (
                                <Grid item key={tag.id} style={{maxWidth: '100%'}}>
                                    <Chip label={tag.name} style={{maxWidth: '100%'}}/>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container direction={"row"} justifyContent={"flex-end"}>
                    <StyledSmallButton type={"button"} onClick={() => { history.push('/publisher/manuscript/' + manuscript.id) }}>{t('bookShort.buttonSeeManuscript')}</StyledSmallButton>
                </Grid>
            </StyledContainer>
        </Grid>
    );
}

const StyledContainer = styled(Grid)`
  background-color: #fff;
  padding: 1rem;
`;

const StyledMatchingContainer = styled(Grid)`
  max-width: 300px;
`;

const StyledAuthorImage = styled('img')`
  max-height: 80px;
`;

const StyledH5 = styled('h5')`
  font-size: 1.1rem;
  color: ${Colors.orange};
`;

const StyledH6 = styled('h6')`
  font-weight: normal;
  font-size: 1rem;
  color: ${Colors.violet};
`;

const StyledSpan1 = styled('span')`
  font-weight: 500;
  color: ${Colors.lightViolet};
`;
